import { ModalWindow, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { clsx } from 'clsx';

import { FormModalHeaderLayout } from './FormModalHeaderLayout';
import * as styles from './FormModalLayout.css';

type TFormModalLayoutTypes = 'info' | 'form';
interface IFormModalLayoutProps {
  title?: string;
  shortTitle?: string;
  subtitle?: string;
  header?: React.ReactElement | null;
  footer?: React.ReactElement | null;
  type: TFormModalLayoutTypes;
  open: boolean;
  onClose(): void;
  testId: string;
}

const formWidthFromType: Record<TFormModalLayoutTypes, number> = {
  info: 544,
  form: 616,
};

export const FormModalLayout: React.FC<React.PropsWithChildren<IFormModalLayoutProps>> = ({
  title,
  subtitle,
  children,
  open,
  onClose,
  type,
  shortTitle,
  footer,
  testId,
}) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  return (
    <ModalWindow
      size="M"
      title={isMobile ? shortTitle : undefined}
      header={type === 'info' || isMobile ? null : <FormModalHeaderLayout title={title} subtitle={subtitle} />}
      footer={type === 'info' ? null : footer}
      open={open}
      onClose={onClose}
      width={'100%'}
      height={isMobile ? '100%' : 'auto'}
      maxWidth={formWidthFromType[type]}
      fixed={isMobile}
    >
      <div data-testid={testId} className={clsx(styles['content'], type === 'form' && styles['border'])}>
        {children}
      </div>
    </ModalWindow>
  );
};
